<template>
  <div>


    <b-row>
      <b-col md="6">
        <h4 class="font-weight-bold">Lusetelling - Uke {{licecount.week}}
        </h4>
        <span class="mute">{{licecount.site.number}} {{licecount.site.name}} - Merd {{licecount.cage}}</span>

        
      </b-col>

       <b-col md="6">
        <div class="text-right mb-3">

          <b-row class="float-right mr-1">
            <!-- <b-form-checkbox class="mt-2 mr-3">
              Send ordrebekreftelse
            </b-form-checkbox> -->

            <b-button class="mr-2" variant="default" @click="goBack()">Avbryt</b-button>

            <b-dropdown right split variant="primary" text="Lagre" @click="saveLicecount()">
              <b-dropdown-item @click="deleteLicecount()">Slett</b-dropdown-item>
            </b-dropdown>

          </b-row>

        </div>
      </b-col>
    </b-row>

    <br>

    <b-row>
      <!-- <b-col class="d-none d-xl-block" xl="3">

        <b-card bg-variant="light">
          
          <h6>Uke</h6>
          <h6>{{licecount.week}}</h6>

          <h6>Kunde</h6>
          {{licecount.customer_company.name}}

          <h6>Lokasjon</h6>
          {{licecount.site.number}} - {{licecount.site.name}}

          <h6>Merd</h6>
          {{licecount.cage}}

          <h6>Temperatur sjø</h6>
          {{licecount.temperature_sea}}


        <vue-typeahead-bootstrap class="mb-3" v-model="queryCompany" :ieCloseFix="false" :data="companies"
                      :serializer="(item) => item.name" @hit="customer_company = $event" placeholder="Søk kunde"
                      @input="lookupCompanies" />

          <label>Lokasjon</label>
          <vue-typeahead-bootstrap class="mb-3" v-model="querySites" :ieCloseFix="false" :data="sites"
                  :serializer="(item) => item.number + ' - ' + item.name" @hit="site = $event"
                  placeholder="Søk lokaliteter" @input="lookupSites" /> -->

          <!-- <label>Merd</label>
          <b-form-input class="mb-3" v-model.number="licecount.cage" placeholder="Merd"></b-form-input>

          <label>Temperatur sjø</label>
          <b-form-input class="mb-3" max="30" step="0.1" v-model.number="licecount.temperature_sea" type="number" placeholder="Temperatur sjø"></b-form-input> 

      </b-card>

      </b-col> -->

    <b-row>
 
      <b-col md="12" lg="12" xl="12">

        <!-- Stats cards -->

          <b-row>

            <b-col>
              <b-card>
               <label>Antall fisk</label><h3>{{ details.fish.length }}</h3>
               </b-card>
            </b-col>

            <b-col>
              <b-card>
               <label>Hunnlus</label><h3>{{ details.lice_female | numeralFormat("0,0[.]0") }}</h3>
            </b-card>
            </b-col>

            <b-col>
              <b-card>
               <label>Bevegelige</label><h3>{{ details.lice_moving | numeralFormat("0,0[.]0") }}</h3>
            </b-card>
            </b-col>

            <b-col>
              <b-card>
               <label>Fastsittende</label><h3>{{ details.lice_persist | numeralFormat("0,0[.]0") }}</h3>
            </b-card>
            </b-col>

            <b-col>
              <b-card>
               <label>Skottelus</label><h3>{{ details.lice_skott | numeralFormat("0,0[.]0") }}</h3>
            </b-card>
            </b-col>

            <!-- <b-col>
              <b-card>
               <label>Velferd</label><h3>{{ details.wellfare  | numeralFormat("0,0[.]0") }} </h3>
               </b-card>
            </b-col> -->


          </b-row>
          <br>



          <!-- Fish lice count -->
     
          <b-row>

              
              <b-col md="6" lg="5" xl="5">
                <b-card bg-variant="light">
                <h6 class="text-center">Lusetelling</h6>

                <b-row>

                  <!-- <b-col>
                    <label>Fisk nummer</label>
                    <b-form-input tabindex="0" v-model.number="fish.number" disabled type="number" placeholder="Fisk nummer"></b-form-input>
                  </b-col> -->

                  <b-col md="6" lg="4" xl="3" class="text-center">
                    <label class="text-center">Hunnlus</label>
                    <br>
                      <b-form-spinbutton class="mb-3" size="lg" min="0" max="100" step="1" v-model="fish.lice_female" vertical></b-form-spinbutton>
                    
                  </b-col>
          
                  <b-col md="6" lg="4" xl="3" class="text-center">
                    <label class="text-center">Bevegelige</label>
                    <br>
                    <b-form-spinbutton class="mb-3" size="lg" min="0" max="100" step="1" v-model="fish.lice_moving" vertical></b-form-spinbutton>
                 
                  </b-col>

                  <b-col md="6" lg="4" xl="3" class="text-center">
                    <label class="text-center">Fastsittende</label>
                    <br>
                       <b-form-spinbutton class="mb-3" size="lg" min="0" max="100" step="1" v-model="fish.lice_persist" vertical></b-form-spinbutton>
                  </b-col>

                  <b-col md="6" lg="4" xl="3" class="text-center">
                    <label class="text-center">Skottelus</label>
                    <br>
                       <b-form-spinbutton class="mb-3" size="lg" min="0" max="100" step="1" v-model="fish.lice_skott" vertical></b-form-spinbutton>
                  </b-col>
                         
                </b-row>

                </b-card>
              </b-col>



              <b-col md="6" lg="7" xl="7">
                <b-card bg-variant="light">
                <!-- Fish welfare -->
                <h6 class="text-center">Velferdsregistreringer (0-3)</h6>

                <b-row>

                  <b-col md="4" lg="2" class="text-center">
                    <label class="text-center">Risttap</label>
                      <br>
                      <b-form-spinbutton class="mb-3" size="lg" min="0" max="3" step="1" v-model="fish.fish_shelloss" vertical></b-form-spinbutton>
                      
                  </b-col>
                                
                  <b-col md="4" lg="2" class="text-center">
                    <label class="text-center">Rødbuk</label>
              <br>
                    <b-form-spinbutton class="mb-3" size="lg" min="0" max="3" step="1" v-model="fish.fish_redbelly" vertical></b-form-spinbutton>
                   
                  </b-col>

                  <b-col md="4" lg="2"  class="text-center">
                    <label class="text-center">Sår</label>
                <br>
                    <b-form-spinbutton class="mb-3" size="lg" min="0" max="3" step="1" v-model="fish.fish_wounds" vertical></b-form-spinbutton>
                   
                  </b-col>

                  <b-col md="4" lg="2"  class="text-center">
                    <label class="text-center">Øyeblødning</label>
                   <br>
                    <b-form-spinbutton class="mb-3" size="lg" min="0" max="3" step="1" v-model="fish.fish_eyebleed" vertical></b-form-spinbutton>
                     
                  </b-col>

                  <b-col md="4" lg="2"  class="text-center">
                    <label class="text-center">Finner</label>
                    <br>
                    <b-form-spinbutton class="mb-3" size="lg" min="0" max="3" step="1" v-model="fish.fish_fin" vertical></b-form-spinbutton>
                    
                  </b-col>

                  <b-col md="4" lg="2"  class="text-center">
                    <label class="text-center">Snutesår</label>
                    <br>
                    <b-form-spinbutton class="mb-3" size="lg" min="0" max="3" step="1" v-model="fish.fish_nosewounds" vertical></b-form-spinbutton>
               
                  </b-col>
                         
                </b-row>

                </b-card>
              </b-col>

          </b-row>

            <b-form-input tabindex="4" v-model.number="fish.note" id="inline-form-input-name" class="mt-3 mb-2 mr-sm-2 mb-sm-0" placeholder="Notat"></b-form-input>

            <b-input-group class="mt-3 mr-sm-2 mb-sm-0">
              <b-button tabindex="5" class="mb-3" block @click="addFish()" variant="primary">Legg til</b-button>
            </b-input-group>



            <!-- Fish table -->

            <b-card>
            <h6>Telling oversikt</h6>
            <b-table class="mt-3" v-if="this.details.fish[0] != null" striped hover :fields="fishFields" :items="this.details.fish">

              <template v-slot:cell(number)="data">
                {{ data.value }}
              </template>

              <template v-slot:cell(cages)="data">{{
                      data.item.from_cage
                    }} <span v-if="data.item.to_cage != ''"> - {{
                      data.item.to_cage
                    }} </span> </template>

     
              <template v-slot:cell(fishcount)="data">
                {{ data.value | numeralFormat("0,0[.]") }}
              </template>

              <template v-slot:cell(wellfare)="data">

                  <b-badge class="mr-1" pill v-if="data.item.fish_shelloss == 1" variant="light">Risttap</b-badge>
                  <b-badge class="mr-1" pill v-if="data.item.fish_shelloss == 2" variant="warning">Risttap</b-badge>
                  <b-badge class="mr-1" pill v-if="data.item.fish_shelloss == 3" variant="danger">Risttap</b-badge>

                  
                  <b-badge class="mr-1" pill v-if="data.item.fish_redbelly == 1" variant="light">Rødbuk</b-badge>
                  <b-badge class="mr-1" pill v-if="data.item.fish_redbelly == 2" variant="warning">Rødbuk</b-badge>
                  <b-badge class="mr-1" pill v-if="data.item.fish_redbelly == 3" variant="danger">Rødbuk</b-badge>

                  
                  <b-badge class="mr-1" pill v-if="data.item.fish_wounds == 1" variant="light">Sår</b-badge>
                  <b-badge class="mr-1" pill v-if="data.item.fish_wounds == 2" variant="warning">Sår</b-badge>
                  <b-badge class="mr-1" pill v-if="data.item.fish_wounds == 3" variant="danger">Sår</b-badge>

                  
                  <b-badge class="mr-1" pill v-if="data.item.fish_eyebleed == 1" variant="light">Øyeblødning</b-badge>
                  <b-badge class="mr-1" pill v-if="data.item.fish_eyebleed == 2" variant="warning">Øyeblødning</b-badge>
                  <b-badge class="mr-1" pill v-if="data.item.fish_eyebleed == 3" variant="danger">Øyeblødning</b-badge>

                  
                  <b-badge class="mr-1" pill v-if="data.item.fish_fin == 1" variant="light">Finner</b-badge>
                  <b-badge class="mr-1" pill v-if="data.item.fish_fin == 2" variant="warning">Finner</b-badge>
                  <b-badge class="mr-1" pill v-if="data.item.fish_fin == 3" variant="danger">Finner</b-badge>

                  
                  <b-badge class="mr-1" pill v-if="data.item.fish_nosewounds == 1" variant="light">Snutesår</b-badge>
                  <b-badge class="mr-1" pill v-if="data.item.fish_nosewounds  == 2" variant="warning">Snutesår</b-badge>
                  <b-badge class="mr-1" pill v-if="data.item.fish_nosewounds  == 3" variant="danger">Snutesår</b-badge>

              </template>

              <template v-slot:cell(actions)="data">
                <b-button variant="primary" size="sm" @click="removeFish(data.item)">Fjern</b-button>
              </template>

            </b-table>

            </b-card>
  
      </b-col>

    </b-row> 

    </b-row> 

  </div>
</template>

<script>
import axios from "axios";

import Vue2Filters from "vue2-filters";
import Datepicker from "vuejs-datepicker";
import VueMoment from "vue-moment";
import moment from "moment";
import {debounce } from "lodash";
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";



var dayjs = require('dayjs')
var weekOfYear = require('dayjs/plugin/weekOfYear')
dayjs.extend(weekOfYear)


export default {
  components: {
    
    Datepicker,
    VueMoment,
    moment,
    VueTypeaheadBootstrap
  },
  mixins: [Vue2Filters.mixin],
  data() {
    return {
      user: {},
      licecount: {},
      fish: {
        wellfare: 0,
        lice_persist: 0,
        lice_moving: 0,
        lice_female: 0,
        fish_shelloss: 0,
        fish_redbelly: 0,
        fish_wounds: 0,
        fish_eyebleed: 0,
        fish_fin: 0,
        fish_nosewounds: 0
      },
      details: {
        fish: []
      },
      order: {},
      orders: [],
      customer_company: {},
      supplier_company: {},
      companies: [],
      site: {},
      sites: [],
      queryOrder: "",
      queryCompany: "",
      querySites: "",
      isLoading: false,
      fishFields: [{
        key: "number",
        label: "Fisk nummer",
        sortable: true,
      },
      {
        key: "lice_female",
        label: "Hunnlus",
        sortable: true,
      },
      {
        key: "lice_moving",
        label: "Bevegelige",
        sortable: true,
      },
      {
        key: "lice_persist",
        label: "Fastsittende",
        sortable: true,
      },
      {
        key: "wellfare",
        label: "Velferd",
        sortable: true,
      },
      {
        key: "note",
        label: "Notat",
        sortable: false,
        tdClass: "notemaxwidth",
      },
      {
        key: "actions",
        label: "",
        sortable: false,
      },
    ],
    };
  },
  computed: {},
  props: ["id"],
  methods: {
    getUser() {
        axios.get("https://api.eines-as.no/users/me").then((res) => {
          this.user = res.data;
          this.customer_company = res.data.company;
        });
      },
    getLicecount() {
        this.isLoading = true;
        axios
          .get(`https://api.eines-as.no/licecounts/${this.id}`)

          .then((response) => {
            console.log(response.data)
            this.licecount = response.data;
            this.details = response.data.details
            this.fish.number = this.licecount.number

            this.isLoading = false;
          })
    },
    saveLicecount() {

      this.isLoading = true;

        // Save licecount
        
        this.licecount.details = this.details

        axios.put("https://api.eines-as.no/licecounts/" + this.licecount.id , this.licecount)
          .then((response) => {
            console.log(response.data)
            this.$router.push("/customer/licecount-customer");
            this.isLoading = false;
          })
          .catch(function (error) {
            console.log(error);
            this.isLoading = false;
          });
        
    },
    updateLicecount() {

      this.isLoading = true;

        // Update licecount
        
        this.licecount.details = this.details

        axios.put("https://api.eines-as.no/licecounts/" + this.licecount.id , this.licecount)
          .then((response) => {
            console.log(response.data)
            //this.$router.push("/dashboard/licecount");
            this.isLoading = false;
          })
          .catch(function (error) {
            console.log(error);
            this.isLoading = false;
          });
        
    },
    deleteLicecount() {

      this.isLoading = true;

        // Delete licecount
        
        axios.delete("https://api.eines-as.no/licecounts/" + this.licecount.id)
          .then((response) => {
            this.$router.push("/customer/licecount-customer");
            this.isLoading = false;
          })
          .catch(function (error) {
            console.log(error);
            this.isLoading = false;
          });
        
    },
    addFish() {

        // Calculate average licecount
        this.fish.wellfare = (this.fish.fish_shelloss + this.fish.fish_redbelly + this.fish.fish_wounds + this.fish.fish_eyebleed + this.fish.fish_fin +  this.fish.fish_nosewounds)
        
        this.details.fish.push(this.fish);
        //this.details.fishcount = this.cage.biomass / this.cage.averageweight;

        this.licecount.number ++;  

        this.fish = {
          number: this.licecount.number,
          lice_persist: this.fish.lice_persist,
          lice_moving: this.fish.lice_moving,
          lice_female: this.fish.lice_female,
          fish_shelloss: this.fish.fish_shelloss,
          fish_redbelly: this.fish.fish_redbelly,
          fish_wounds: this.fish.fish_wounds,
          fish_eyebleed: this.fish.fish_eyebleed,
          fish_fin: this.fish.fish_fin,
          fish_nosewounds: this.fish.fish_nosewounds
        }
              
       // Calculate average lice moving
           this.details.lice_persist = this.details.fish.reduce(function (average, fish) {
                return average + fish.lice_persist;
            }, 0) / this.details.fish.length;

       // Calculate average lice moving
           this.details.lice_moving = this.details.fish.reduce(function (average, fish) {
                return average + fish.lice_moving;
            }, 0) / this.details.fish.length;

       // Calculate average lice female
           this.details.lice_female = this.details.fish.reduce(function (average, fish) {
                return average + fish.lice_female;
            }, 0) / this.details.fish.length;

         // Calculate fish wellfare score
           this.details.wellfare = this.details.fish.reduce(function (average, fish) {
                return average + fish.wellfare;
            }, 0) / this.details.fish.length;


          this.updateLicecount()


      },
      removeFish(fish) {
        let index = this.details.fish.indexOf(fish);
        this.details.fish.splice(index, 1);


       // Calculate average lice moving
           this.details.lice_persist = this.details.fish.reduce(function (average, fish) {
                return average + fish.lice_persist;
            }, 0) / this.details.fish.length;

       // Calculate average lice moving
           this.details.lice_moving = this.details.fish.reduce(function (average, fish) {
                return average + fish.lice_moving;
            }, 0) / this.details.fish.length;

       // Calculate average lice female
           this.details.lice_female = this.details.fish.reduce(function (average, fish) {
                return average + fish.lice_female;
            }, 0) / this.details.fish.length;

         // Calculate fish wellfare score
           this.details.wellfare = this.details.fish.reduce(function (average, fish) {
                return average + fish.wellfare;
            }, 0) / this.details.fish.length;

          this.updateLicecount()
      },
      goBack() {
        this.$router.push("/customer/licecount-customer");
      },
  },
  created: function () {
    this.getUser()
    this.getLicecount()
  },
};
</script>

<style lang="css">
.country-flag {
  max-width: 20px;
  box-shadow: inset 0px 0px 10px rgba(0, 0, 0, 0.9);
}

.flscellmaxwidth {
  max-width: 300px;
}

/*
 * Link
 */

/* Links */

.link {
  color: #484848;
}

/* unvisited link */
.link:link {
  color: #484848 !important;
}

/* visited link */
.link:visited {
  color: #484848 !important;
}

/* mouse over link */
.link:hover {
  color: #6e6e6e !important;
}

/* selected link */
.link:active {
  color: #484848 !important;
}

.table .table-success,
.table .table-success > th,
.table .table-success > td {
  background-color: #e4fae9;
}
</style>